const Membership = {
  REGISTERED: 'registered',
  CLASSIC: 'classic',
  SILVER: 'silver',
  GOLD: 'gold',
}

export { Membership }
